import React from 'react';
import './input.scss';

const Input = ({
  value,
  label,
  placeholder,
  error,
  onChange = () => {},
  onBlur = () => {},
  size,
  type,
}) => {
  return (
    <div className="input-main-container">
      <div>{label}</div>
      <div className={`input-container ${error}`}>
        <div className="input-div">
          <input
            value={value}
            className={`input-input  ${size}`}
            placeholder={placeholder}
            type={type}
            onChange={(e) => onChange(e)}
            onBlur={onBlur}
          />
        </div>
      </div>
    </div>
  );
};
export default Input;
